import {makeStyles} from '@material-ui/core/styles'
import {estilosTextosPrincipales, backgroundRectangle, colores} from '../../../AppStyle'

export const customStyle = makeStyles ({
    backgroundRectangle:{
        ...backgroundRectangle
    },
    pageTitle:{
        ...estilosTextosPrincipales.encabezadoH2,
        fontWeight: 'normal',
        color: colores.escalaGrises.cien
    },
    gridPageTitle:{
        marginLeft: '5%',
        marginTop: '2%'
    },
    gridSearchBar:{
        marginRight: '5%',
        marginLeft: '5%',
        marginTop: '2%',
        alignSelf: 'center'
    },
    gridTablePager:{
        marginTop: '0.5%',
        marginRight: '4%',
        width: '85%',
    },
    gridTableResponsivePager:{
        marginTop: '0.5%',
        width: '90%',
    },
    gridTable:{
        marginBotton: '0.5%'
    },
    classLine1: {
        boxSizing: 'borderBox',
        height: '1px',
        width: '90%',
        border: '1px',
        borderStyle: 'solid',
        borderColor: 'red',
        marginTop: '13px',
        marginBottom: '23px'
    },
    classBackdrop: {
      zIndex: 1,
      color: '#fff',
    }
});
